import { Button, Card, Descriptions, Form, Spin } from 'antd';
import React from "react";
import { getFormFieldByType } from "../../util/methods";
import SubList from "../../components/PreVerificationSubList";
import './style.css';

class View extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      subData: [{}],
      urlQueryCode: '',
    };
  }

  componentDidMount() {
    const { match, fetch } = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }

    const queryString = this.props.location.search;
    const params = new URLSearchParams(queryString);
    const code = params.get('assetCode');
    if (code)
      this.setState({
        urlQueryCode: code
      })
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps && nextProps.data && JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)) {
      this.setState({ subData: nextProps.data.assetDetails })
    }
  }

  handleSubmit = (e) => {
    const { match } = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }


    });
  };

  handleError = err => {
    console.error(err)
  };

  componentWillUnmount() {
    this.props.clearData();
  }

  submitReport = (id) => {
    this.props.submitReport(id);
  }

  reOpenPvVerification = () => {
    const { match, fetch } = this.props;
    if (match.params && match.params.id) {
      this.props.reOpenPvVerification(match.params.id);
    }
  }


  render() {
    const { getFieldDecorator, setFieldsValue } = this.props.form;
    const { data, loading, filters, title, resource, subDocumentFilters, form, authUser } = this.props;
    const { subData } = this.state;
    let conditionAccordingTOPermission = false;
    // if (authUser && authUser.roles[0].access.length > 0) {
    //   authUser.roles[0].access.map((item) => {
    //     if (item.name === 'PreVerification') {
    //       if (item.permissions.includes('reopen')) {
    //         conditionAccordingTOPermission = true;
    //       }
    //     }
    //   })
    // }
    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">
            <Descriptions layout="horizontal">
              <Descriptions.Item label={<span className={'label-heading'}>PV No</span>}>{data && data.pvNo}</Descriptions.Item>
              <Descriptions.Item label={<span className={'label-heading'}>Audit Voucher</span>}>{data && data.auditVoucher && data.auditVoucher.voucherNo}</Descriptions.Item>
              <Descriptions.Item label={<span
                className={'label-heading'}>Location</span>}>{data && data.location && data.location.name}</Descriptions.Item>
              <Descriptions.Item label={<span
                className={'label-heading'}>Sub Location</span>}>{data && data.client && data.client.name}</Descriptions.Item>
              <Descriptions.Item label={<span
                className={'label-heading'}>Opened By</span>}>{data && data.openedBy && data.openedBy.name}</Descriptions.Item>

            </Descriptions>
            <div className={'asset-stock-taking'}>
              {Object.keys(filters).map((item, index) => {

                if (filters[item].type === 'Array' && filters[item].schema) {
                  if (filters[item].field === 'assetDetails') {
                    return <SubList urlQueryCode={this.state.urlQueryCode} key={item} item={filters[item]} form={form}
                      pv={data._id} isApproved={data && data.isApproved}
                      openedBy={data && data.openedBy}
                      latitude={data && data.latitude}
                      longitude={data && data.longitude} data={subData} title={title}
                      resource={resource} subDocumentFilters={subDocumentFilters}
                      match={this.props.match} history={this.props.history}
                      notSubmitted={!!(data && data.status && data.status === 'OPEN')}
                      onSubmitWithDocument={this.props.onSubmitWithDocument}
                      onUpdateAssetDetailField={this.props.onUpdateAssetDetailField}
                      onRemoveAssetDetail={this.props.onRemoveAssetDetail} />
                  }
                } else {
                  if (item !== 'client' && item !== 'location' && item !== 'user' && item !== 'auditVoucher') {
                    return getFormFieldByType(filters, item, getFieldDecorator, data, {
                      resource,
                      title,
                      setFieldsValue
                    })
                  }
                }
              })}
            </div>

            {data && data.status && (data.status === 'SUBMITTED' || data.status === 'COMPLETED') ? <>
              <b>Status</b>: Report Submitted </> : <><b>Status</b>: OPEN </>}

            <Form.Item>
              {
                data && data.status && data.status === 'OPEN' ?
                  <Button type="primary" className="gx-mb-0"
                    onClick={() => this.props.history.push(`/pre-verification/edit/${data && data._id}`)}>
                    Scan more Assets
                  </Button> : ''
              }
              {
                data && data.status && data.status === 'OPEN' ?
                  <Button type="primary" className="gx-mb-0"
                    onClick={() => this.submitReport(data && data._id)}>
                    Submit Report
                  </Button> : ''
              }
            </Form.Item>
          </Form>
          {/* Re-Open removed: once a PV is submitted it can no longer be re-opened. */}
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(View);

export default CreateForm;
